<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Usuário">
      <b-container fluid class="mt-4 scrollable-area">
        <b-form>
          <div class="inputs-group px-3 py-3 mb-5">
            <h3 class="mb-4">Insira sua senha</h3>
            <b-row>
              <b-col>
                <b-form-group label="Senha" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="user.password"
                    type="text"
                    autocomplete="off"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="justify-content-end px-3 py-3 mb-3">
              <b-col class="col-6" sm="4" md="3" lg="2">
                <b-button
                  type="button"
                  variant="danger"
                  v-on:click="goBackToHome"
                >
                  Cancelar
                </b-button>
              </b-col>
              <b-col class="col-6" sm="4" md="3" lg="2">
                <b-button
                  type="button"
                  variant="success"
                  v-on:click="confirmPassword"
                >
                  Salvar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-container>
    </Dashboard>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import HeaderVue from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import Dashboard from '../components/Dashboard.vue';
import { ConfirmUser } from '../services/Users';
import showError from '../utils/showError';

export default {
  mixins: [validationMixin],
  components: { HeaderVue, Sidebar, Dashboard },
  data() {
    return {
      user: {
        password: '',
      },
    };
  },
  methods: {
    confirmPassword() {
      const { token } = this.$route.params;
      ConfirmUser(token, this.user)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.goBackToHome();
        })
        .catch((error) => {
          showError(error);
        });
    },
    goBackToHome() {
      this.$router.push('/produtos');
    },
  },
};
</script>

<style scoped>
form,
h3 {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #121212;
}

.inputs-group {
  background: rgba(217, 217, 217, 0.54);
  border-radius: 20px;
}

button {
  border: none;
  padding: 8px 40px 8px 40px;
  border-radius: 24px;
  color: white;
  font-weight: 400;
  font-size: 18px;
}
</style>
